import { vModelText as _vModelText, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svgs/icons/calendar.svg'


const _withScopeId = n => (_pushScopeId("data-v-61505376"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "calendar"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"19px","font-weight":"700"} }, "Select time period", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"1px","background-color":"#dadbe6"} }, null, -1))
const _hoisted_5 = { class: "flex-m mb-3" }
const _hoisted_6 = { class: "flex-m" }
const _hoisted_7 = { class: "flex-m" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"1px","background-color":"#dadbe6"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_span = _resolveComponent("v-span")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_VButtonGroup = _resolveComponent("VButtonGroup")!
  const _component_InputTypeDate = _resolveComponent("InputTypeDate")!
  const _component_VButton = _resolveComponent("VButton")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: _ctx.width })
  }, [
    _withDirectives(_createElementVNode("input", {
      readonly: "",
      style: _normalizeStyle({ height: _ctx.height }),
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.combinedDate) = $event))
    }, null, 4), [
      [_vModelText, _ctx.combinedDate]
    ]),
    _createVNode(_component_v_span, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShow = !_ctx.isShow))
    }, _hoisted_2),
    _createElementVNode("ul", {
      class: _normalizeClass(["hidden", { show: _ctx.isShow }]),
      style: _normalizeStyle({ width: _ctx.widthContent })
    }, [
      _createVNode(_component_v_container, { class: "pb-5" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(_component_VButtonGroup, {
        class: "mt-4",
        onDate: _ctx.onThisEvent
      }, null, 8, ["onDate"]),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "sort",
            style: {"padding":"8px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_InputTypeDate, {
                    label: 'From',
                    date: _ctx.searchConfirm.startDate,
                    min: _ctx.dateNow,
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchConfirm.startDate = $event.target?.value))
                  }, null, 8, ["date", "min"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_InputTypeDate, {
                    label: 'To',
                    date: _ctx.searchConfirm.endDate,
                    min: _ctx.searchConfirm.startDate,
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchConfirm.endDate = $event.target?.value))
                  }, null, 8, ["date", "min"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_8,
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "d-flex justify-end mt-1",
            style: {"gap":"10px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VButton, {
                message: 'Cancel',
                radius: '20px',
                bgColor: '#fff',
                bgBorder: '1px solid #dadbe6',
                width: '10rem',
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShow = false))
              }),
              _createVNode(_component_VButton, {
                onClick: _ctx.onSearch,
                message: 'Confirm',
                radius: '20px',
                bgColor: '#3DC0CB',
                width: '10rem',
                fontColor: 'white'
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 6)
  ], 4))
}